import { Box, Button, Colors, IcAddress, IcChevronLeft, IcPhone, IcReplace, IcTrash, Row, Text } from 'basic-ui-lib';
import storeApis from 'modules/store/services/apis';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { getMessageError } from 'services/response';
import styled from 'styled-components';
import toast from 'utils/toast';
import ModalConfirm, { useModalConfirmRef } from 'widgets/ModalConfirm';

const HeaderAction = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { storeName, phone, address } = location.state || {};
  const modalConfirmRef = useModalConfirmRef();
  const { id } = useParams<{ id: string }>();

  const handleBack = () => {
    navigate(-1);
  };
  
  const handleDelete = async (storeId: string) => {
    try {
      const res = await storeApis.deleteStore(storeId);

      if (res?.data?.data) {
        toast.success('Store deleted successfully');
        navigate(-1);
      }
    } catch (error) {
      toast.error(getMessageError(error) || 'Failed to delete store');
    }
  };

  const onDeleteStore = (storeId: string) => {
    modalConfirmRef.current?.open(() => handleDelete(storeId), {
      message: 'Are you sure you want to delete this store? This action cannot be undone.',
    });
  };

  return (
    <Container>
      <Row gap={16}>
        <button onClick={handleBack} className='title'>
          <IcChevronLeft />
          <Text title_h7 medium>
            {storeName}
          </Text>
        </button>
        <Row gap={32}>
          <Row>
            <Box className='icon-box'>
              <IcPhone width={16} height={16}/>
            </Box>
            <Text title_h8 regular>
              {phone}
            </Text>
          </Row>
          <Row>
            <Box className='icon-box'>
              <IcAddress width={16} height={16}/>
            </Box>
            <Text title_h8 regular>
              {address}
            </Text>
          </Row>
        </Row>
      </Row>
      <Row>
        <Button lg type_delete prefix={<IcTrash width={20} height={20} fill={Colors.other[3]} />} onClick={() => onDeleteStore(id || '')}>
          Delete
        </Button>
        <Button lg type_new prefix={<IcReplace width={20} height={20} fill={Colors.primary[5]} />}>
          Edit Information
        </Button>
      </Row>
      <ModalConfirm ref={modalConfirmRef} />
    </Container>
  );
};

export default HeaderAction;

const Container = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-bottom: 8px;

  .title {
    display: flex;
    align-items: center;
    gap: 16px;
    background: none;
    border: none;
  }
    
  .icon-box {
    width: 24px;
    height: 24px;
    display: flex;
    align-items: center;
    justify-content: center;
    background: ${Colors.neutral.bg[3]};
    border-radius: 100px;
  }
`;
